import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Calendar } from '@ionic-native/calendar';
import { GoogleMaps } from '@ionic-native/google-maps';
import { Geolocation } from '@ionic-native/geolocation';
import { NativeGeocoder } from '@ionic-native/native-geocoder';
import { LocationAccuracy } from '@ionic-native/location-accuracy';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Diagnostic } from '@ionic-native/diagnostic';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { File } from '@ionic-native/file';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';
import { FileTransfer } from '@ionic-native/file-transfer';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { HttpModule } from '@angular/http';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { NgxBarcodeModule } from 'ngx-barcode';
import { SQLite } from '@ionic-native/sqlite';
import { SMS } from '@ionic-native/sms';
import { AppRate } from '@ionic-native/app-rate';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { StoreLocatorPage } from '../pages/store-locator/store-locator';
import { MedicineStocklocPage } from '../pages/medicine-stockloc/medicine-stockloc';
import { MedlocResultsPage } from '../pages/medloc-results/medloc-results';
import { MedlocViewmapPage } from '../pages/medloc-viewmap/medloc-viewmap';
import { ViewSelectBranchPage } from '../pages/view-select-branch/view-select-branch';
import { TransformProvider } from '../providers/transform/transform';
import { DataProvider } from '../providers/data/data';
import { HttpClientModule } from '@angular/common/http';
import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';

import { Screenshot } from '@ionic-native/screenshot/ngx';
import { GoogleMapComponent } from '../components/google-map/google-map';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    StoreLocatorPage,
    MedicineStocklocPage,
    MedlocResultsPage,
    MedlocViewmapPage,
    ViewSelectBranchPage,
    GoogleMapComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    NgxQRCodeModule,
    HttpModule,
    HttpClientModule,
    NgxBarcodeModule,
    IonicModule.forRoot(MyApp, { platforms: { android: { scrollAssist: false, autoFocusAssist: false } }})

  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    StoreLocatorPage,
    MedicineStocklocPage,
    MedlocResultsPage,
    MedlocViewmapPage,
    ViewSelectBranchPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    LocalNotifications,
    Calendar,
    GoogleMaps,
    Geolocation,
    NativeGeocoder,
    LocationAccuracy,
    BarcodeScanner,
    Diagnostic,
    File,
    FilePath,
    Camera,
    FileTransfer,
    PhotoViewer,
    InAppBrowser,
    SQLite,
     ImagePicker,
    Base64,
    SMS,
    AppRate,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    TransformProvider,
    DataProvider,
    Screenshot
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts